import axios from "axios";
import React from "react";
import { useQuery } from "react-query";
import { BASEURL } from "../../../utils/BaseUrl";
import LeadCountCard from "./LeadCountCard";
import BrochureCount from "./BrochureCount";
import ApplicationCount from "./ApplicationCount";
import DashboardTitle from "./DashboardTitle";
import TraingleLoading from "../../../common/Loading/TraingleLoading";

const AdminDashboard = () => {
  const { data: leadCount, isLoading } = useQuery({
    queryKey: "getLeadCount",
    queryFn: () =>
      axios.get(`${BASEURL}lead-count`).then((res) => {
        return res?.data;
      }),
  });
  const { data: applicationCount } = useQuery({
    queryKey: "getApplicationcount",
    queryFn: () =>
      axios.get(`${BASEURL}application-count`).then((res) => {
        return res?.data;
      }),
  });
  const { data: brochurecount } = useQuery({
    queryKey: "getbrochurecount",
    queryFn: () =>
      axios.get(`${BASEURL}brochure-count`).then((res) => {
        return res?.data;
      }),
  });
  return (
    <div>
      {isLoading && <TraingleLoading />}
      <div>
        <DashboardTitle>Enquire Details</DashboardTitle>
        <LeadCountCard count={leadCount?.count} />
      </div>
      <div>
        <DashboardTitle>Brochure Details</DashboardTitle>
        <BrochureCount brochurecount={brochurecount?.downloadCounts} />
      </div>
      <div>
        <DashboardTitle>Application Details</DashboardTitle>
        <ApplicationCount applicationCount={applicationCount?.data} />
      </div>
    </div>
  );
};

export default AdminDashboard;
